import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-wow-slider',
  templateUrl: './wow-slider.component.html',
  styleUrls: ['./wow-slider.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WowSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/wow-slider/wow-slider.component.ts